<template>
  <div v-html="html"></div>
</template>

<script>
  import Qs from 'qs'
export default {
  name: "PayMethods",
  data() {
    return {
      html:'支付宝支付详情页',
      timer: ''
    };
  },
  methods: {
    fetchVideoPay(){
      let params = {
        orderId: this.$route.query.orderId,
        /* 支付后支付宝return的url */
        // returnUrl: 'www.baidu.com''window.location.origin + window.location.pathname + '?orderId=' + this.$route.query.orderId'
        returnUrl: window.location.origin + window.location.pathname + '#/success' + '?orderId=' + this.$route.query.orderId
      };
      let strParams = Qs.stringify(params);
      this.$Api.getPayDetail(strParams).then(res => {
        /*console.log(res);*/
        if (res.code == 500 || res.code == '500') {
          this.$toast.fail('获取订单失败，请稍后重试');
        } else {
          let orderAndUserVO = res.orderAndUserVO;
          this.html = decodeURI(orderAndUserVO.aliUrl);

          this.$nextTick(() => {
            document.forms[0].submit();   //渲染支付宝支付页面
          });
        }
      }).catch(err => {
        this.$toast("服务器错误，请稍后重试！");
      });
    }
  },
  mounted(){
    this.fetchVideoPay()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-title{
    text-align: center;
    font-size: 15px;
    color: #282828;
    font-family: PingFangSC-Semibold;
    position: relative;
    padding-bottom: 7px;
    box-sizing: border-box;
}

.common-title:before{
    content: '';
    display: block;
    width: 100px;
    height: 1px;
    background: #DEDEDE;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -50px;
}

.common-title:after{
    content: '';
    display: block;
    width: 20px;
    height: 3px;
    background: #398DEE;
    position: absolute;
    bottom: -1px;
    left: 50%;
    margin-left: -10px;
    border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/layout/PayMethods/index.vue